import React, { useState } from "react";
import UseGetDashBoardWithParams from "../../../../../Components/Hooks/useDashboardDataParams";
import capitalizeFirstLetter from "../../../../../Components/Utils/Funcs";

const SalesMan = () => {
  const currentMonthIndex = new Date().getMonth() + 1;
  const [params, setParams] = useState({
    month: currentMonthIndex,
  });
  const [selectedMonth, setSelectedMonth] = useState(currentMonthIndex);

  const { data, loading } = UseGetDashBoardWithParams(`/new-dashboard/sales/ypr-actioned`, params);

  const handleMonthChange = (e) => {
    const newMonth = parseInt(e.target.value);
    setParams({ ...params, month: newMonth });
    setSelectedMonth(newMonth);
  };

  const months = [
    { name: "January", value: 1 },
    { name: "February", value: 2 },
    { name: "March", value: 3 },
    { name: "April", value: 4 },
    { name: "May", value: 5 },
    { name: "June", value: 6 },
    { name: "July", value: 7 },
    { name: "August", value: 8 },
    { name: "September", value: 9 },
    { name: "October", value: 10 },
    { name: "November", value: 11 },
    { name: "December", value: 12 },
  ];

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Salesman YPR Performance</h3>
        </div>

        <select
          value={selectedMonth}
          onChange={handleMonthChange}
          className="bg-gray-50 border border-gray-200 rounded-lg px-2.5 py-1 text-xs font-medium text-gray-700 outline-none"
        >
          {months.map((m) => (
            <option key={m.value} value={m.value}>
              {m.name}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="h-48 flex items-center justify-center animate-pulse space-y-2">
          <div className="h-32 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">Sales Representative</th>
                <th className="py-2 px-1 text-center">Total</th>
                <th className="py-2 px-1 text-center">Quotes</th>
                <th className="py-2 px-1 text-center">Rem.</th>
                <th className="py-2 px-1 text-center">Ord. Rev.</th>
                <th className="py-2 px-2 text-right">Win Rate</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data && data.length > 0 ? (
                data.map((item, index) => {
                  const winRate = parseFloat(item?.Wining || 0).toFixed(1);
                  return (
                    <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                      <td className="py-2.5 px-2 font-medium text-gray-800 truncate max-w-[120px]">
                        {capitalizeFirstLetter(item?.name || "N/A")}
                      </td>
                      <td className="py-2.5 px-1 text-center font-semibold text-gray-800">{item?.total || 0}</td>
                      <td className="py-2.5 px-1 text-center text-purple-600 font-semibold">{item?.submited || 0}</td>
                      <td className="py-2.5 px-1 text-center text-amber-600 font-semibold">{item?.remaining || 0}</td>
                      <td className="py-2.5 px-1 text-center text-blue-600 font-semibold">{item?.received || 0}</td>
                      <td className="py-2.5 px-2 text-right">
                        <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200/50">
                          {winRate}%
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={6} className="py-6 text-center text-gray-400">
                    No actioned data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SalesMan;
